import { getAgingEmailTemplatesQuery, SageInvoiceAgingReminderConnectionQuery, sendAgingInvoiceNoticeMutation } from './sage-invoice-aging-reminder.operations';
import { IApiAgingInvoiceEmailTemplate, IApiAgingNoticeInput, IApiSageInvoiceAgingReminderConnection, IApiSageInvoiceAgingReminderFilter, IApiSageInvoiceAgingReminderOrderBy } from './../../types/types';
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { IGqlBaseOptions } from '../../interfaces';
import { connectionQuery } from '../../helpers.class';

@Injectable()
export class GqlSageInvoiceAgingReminderService {
    public constructor(
        private apollo: Apollo
    ) { }

    public getAgingEmailTemplates(): Observable<IApiAgingInvoiceEmailTemplate[]> {
        return this.apollo.query({
            query: getAgingEmailTemplatesQuery,
        }).pipe(
            safeResolve(true)
        );
    }

    public sendAgingInvoiceNotice(input: IApiAgingNoticeInput): Observable<{ success: boolean, message: string }> {
        return this.apollo.mutate({
            mutation: sendAgingInvoiceNoticeMutation,
            variables: { input }
        }).pipe(
            safeResolve(true)
        );
    }

    public sageInvoiceAgingReminders(filters: IApiSageInvoiceAgingReminderFilter[], options: IGqlBaseOptions): Observable<IApiSageInvoiceAgingReminderConnection> {
        return this.apollo.query(connectionQuery(SageInvoiceAgingReminderConnectionQuery, filters, options)).pipe(
            safeResolve(true)
        );
    }
}
